import { DiffEditorProps } from '@monaco-editor/react'
import gitDiffParser, { Change, File, Hunk } from 'gitdiff-parser'

/**
 * Parses a Git diff string into separate original and modified file contents,
 * suitable for rendering in the Monaco Diff Viewer.
 *
 * Limitations:
 * - Supports diffs between exactly two files.
 * - Automatically generates line numbers for each file.
 */
export const unwrapGitDiffForMonacoDiffViewer = (
  diff: string,
): Required<Pick<DiffEditorProps, 'modified' | 'original'>> => {
  const parsed: File[] = gitDiffParser.parse(diff)
  if (parsed.length !== 1) {
    throw new Error('Expected diff for a single file.')
  }

  const originalLines: string[] = []
  const modifiedLines: string[] = []

  parsed[0].hunks.forEach((hunk: Hunk): void => {
    let beforeLineNumber: number = hunk.oldStart
    let afterLineNumber: number = hunk.newStart

    hunk.changes.forEach((change: Change): void => {
      const { content } = change

      switch (change.type) {
        case 'delete':
          originalLines.push(` ${beforeLineNumber}${content}`)
          beforeLineNumber++
          break
        case 'insert':
          modifiedLines.push(` ${afterLineNumber}${content}`)
          afterLineNumber++
          break
        case 'normal':
          originalLines.push(` ${beforeLineNumber}${content}`)
          modifiedLines.push(` ${afterLineNumber}${content}`)
          beforeLineNumber++
          afterLineNumber++
          break
      }
    })
  })

  return {
    modified: modifiedLines.join('\n'),
    original: originalLines.join('\n'),
  }
}
